import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import CasesCreateTroubleTicket from './CasesCreateTroubleTicket'
import { createTroubleTicket } from 'features/Cases/Cases.actions'
import { get, flow } from 'lodash'

const formName = 'createTroubleTicket'

const stateToProps = ({ form }, { serviceId }) => ({
  formData: get(form, [formName, 'values'], {}),
  initialValues: {
    serviceId,
  },
})

const dispatchToProps = {
  createTroubleTicket,
}

export default flow(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(CasesCreateTroubleTicket)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesCreateTroubleTicket/CasesCreateTroubleTicket.container.js